var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from 'styled-components';
import omit from "lodash/omit";
import { FLEX, FLEX_NOWRAP, FLEX_ROW, FLEX_COLUMN } from "../../classConstants";
import { getClassName } from "../../helpers";
var getDirection = function (direction, reverse) {
    return direction + (reverse ? '-reverse' : '');
};
export var FlexNoStyle = function (props) {
    var _a = props.as, El = _a === void 0 ? 'div' : _a, _b = props.isInline, isInline = _b === void 0 ? true : _b, flex = props.flex, _c = props.reverse, reverse = _c === void 0 ? false : _c, className = props.className, elementProps = __rest(props, ["as", "isInline", "flex", "reverse", "className"]);
    var classList = [className, FLEX];
    var direction = isInline ? FLEX_ROW : FLEX_COLUMN;
    classList.push(getDirection(direction, reverse));
    return (React.createElement(El, __assign({ style: { flex: flex }, className: getClassName(classList) }, omit(elementProps, "singleColumn"))));
};
export var Flex = styled(FlexNoStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &.", " {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    &.", " {\n        flex-wrap: nowrap;\n    }\n\n    &.", " {\n        flex-direction: row;\n        align-items: center;\n    }\n\n    &.", " {\n        flex-direction: column;\n    }\n\n    &.", " {\n        flex-direction: row-reverse;\n        justify-content: flex-end;\n        align-items: center;\n    }\n\n    &.", " {\n        flex-direction: column-reverse;\n        justify-content: flex-end;\n    }\n"], ["\n    &.", " {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    &.", " {\n        flex-wrap: nowrap;\n    }\n\n    &.", " {\n        flex-direction: row;\n        align-items: center;\n    }\n\n    &.", " {\n        flex-direction: column;\n    }\n\n    &.", " {\n        flex-direction: row-reverse;\n        justify-content: flex-end;\n        align-items: center;\n    }\n\n    &.", " {\n        flex-direction: column-reverse;\n        justify-content: flex-end;\n    }\n"])), FLEX, FLEX_NOWRAP, FLEX_ROW, FLEX_COLUMN, getDirection(FLEX_ROW, true), getDirection(FLEX_COLUMN, true));
var templateObject_1;
